import * as angular from 'angular';
import { MetricsSelectionRowComponent } from './metrics-selection-row-component';

export const MetricsSelectionRowModule = angular
  .module('metricsSelectionRow', [])
  .component('metricsSelectionRow', MetricsSelectionRowComponent).name;
